import { PropertyAddress } from '../types/accounts.types';
import memoize from 'fast-memoize';

/**
 * Formatting the address
 * @param address of type property Address
 * @returns concatenated string
 */
export const addressFormat = memoize((address: PropertyAddress) => {
    return `${camelCase(address.address1)} ${camelCase(address.address2)}, ${camelCase(address.city)}, ${address.state}, ${address.zip}`;
});

export const camelCase = memoize((str: string) => {
    if (str === '') return str;
    return str
        .split(' ')
        .map((s: string) => `${s.charAt(0).toUpperCase()}${s.substring(1).toLowerCase()}`)
        .join(' ');
});
